import React from 'react';

import Container from 'components/Container';

import { gosuslugi, partners } from '../../helpers';

import styles from './styles.module.scss';

const Footer = () => (
	<Container innerClassName={styles.block}>
		<div className={styles.contacts}>
			<div className={styles.title}>Пушкинская карта на портале</div>
			<a
				className={styles.link}
				href="https://culture.gosuslugi.ru"
				target="_blank"
				rel="noopener"
			>
				{gosuslugi}
			</a>
			<div className={styles.tel}>
				телефон горячей линии <a href="tel:+78001000645">8-800-100-06-45</a>
			</div>
		</div>
		<div className={styles.partners}>
			{partners.map(({ url, svg, title }) => (
				<a
					key={url}
					href={url}
					target="_blank"
					rel="noopener"
					className={styles.partnerLink}
					aria-label={title}
				>
					{svg}
				</a>
			))}
		</div>
	</Container>
);

export default Footer;
